const oopsibopMoodControllers = new WeakMap();

function initOopsibopMood(root = document) {
  root.querySelectorAll('[data-mood-selector]').forEach((selector) => {
    if (selector.dataset.initialized) return;
    selector.dataset.initialized = 'true';
    const controller = new AbortController();
    oopsibopMoodControllers.set(selector, controller);
    const listen = (node, type, handler) => node?.addEventListener(type, handler, { signal: controller.signal });
    const slides = [...selector.querySelectorAll('[data-mood-slide]')];
    if (slides.length < 1) return;
    const counter = selector.querySelector('[data-mood-counter]');
    let active = 0;
    let startX = null;

    function setActive(next) {
      active = (next + slides.length) % slides.length;
      slides.forEach((slide, index) => {
        const selected = index === active;
        slide.classList.toggle('is-active', selected);
        slide.setAttribute('aria-hidden', String(!selected));
        if (selected) slide.removeAttribute('inert'); else slide.setAttribute('inert', '');
      });
      const slide = slides[active];
      selector.style.setProperty('--mood', slide.dataset.primary);
      selector.style.setProperty('--mood-soft', slide.dataset.secondary);
      selector.style.setProperty('--mood-ink', slide.dataset.ink);
      if (counter) counter.textContent = `${String(active + 1).padStart(2, '0')} / ${String(slides.length).padStart(2, '0')}`;
    }

    listen(selector.querySelector('[data-mood-prev]'), 'click', () => setActive(active - 1));
    listen(selector.querySelector('[data-mood-next]'), 'click', () => setActive(active + 1));
    listen(selector, 'keydown', (event) => {
      if (event.key === 'ArrowLeft') { event.preventDefault(); setActive(active - 1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); setActive(active + 1); }
    });
    listen(selector, 'pointerdown', (event) => { if (event.pointerType !== 'mouse') startX = event.clientX; });
    listen(selector, 'pointerup', (event) => {
      if (startX === null) return;
      const distance = event.clientX - startX;
      startX = null;
      if (Math.abs(distance) >= 45) setActive(active + (distance < 0 ? 1 : -1));
    });
    setActive(0);
  });
}

function unloadOopsibopMood(root) {
  root.querySelectorAll('[data-mood-selector]').forEach((selector) => {
    oopsibopMoodControllers.get(selector)?.abort();
    oopsibopMoodControllers.delete(selector);
    delete selector.dataset.initialized;
  });
}

document.addEventListener('DOMContentLoaded', () => initOopsibopMood());
document.addEventListener('shopify:section:load', (event) => initOopsibopMood(event.target));
document.addEventListener('shopify:section:unload', (event) => unloadOopsibopMood(event.target));
